import React, { useContext, useEffect, useState } from 'react'
import styled, { css } from 'styled-components'
import media from 'css-in-js-media'
import Img from 'gatsby-image'
import MapPin from '../svg/interactive-map-pin.svg'

import LayoutContext from './LayoutContext'
import { StyledHeading } from './Heading'
import { DesktopView, FullAbsolute, MobileView } from '../styles/Utils'
import InteractiveMapSlider from './InteractiveMapSlider'
import { Variables } from '../styles/Variables'
import { Tab, TabContent, Tabs, TabsWrap } from './Tabs'

export const InteractiveMapSection = styled.div``

const Inner = styled.div`
    position: relative;

    ${media('<desktop')} {
        height: 375px;
        .gatsby-image-wrapper {
            height: 100%;
        }
        img {
            object-fit: cover !important;
            width: 100%;
            height: 100%;
        }
    }
`

const SecondaryInner = styled.div`
    position: relative;
    max-width: 1200px;
    margin: auto;
`

const Pins = styled.div`
    ${FullAbsolute}
    z-index: 10;
`

const Pin = styled.div`
    position: absolute;
    left: ${({ $x }) => ($x ? `${$x}%` : '0px')};
    top: ${({ $y }) => ($y ? `${$y}%` : '0px')};

    cursor: pointer;

    svg {
        vertical-align: top;
        transition: 0.4s transform ease-out;
        transition-timing-function: cubic-bezier(0.29, 0.46, 0.1, 1);
        transform: translateY(0);

        ${media('<desktop')} {
            width: 13px;
            height: 18px;
        }
    }

    :hover {
        svg {
            transform: translateY(-10px);
        }
    }
`

const InteractiveMapWrapper = styled.div`
    background-color: ${Variables.color.lightGrey};
    ${StyledHeading} {
        ${media('>=desktop')} {
            padding-top: 22px;
            padding-bottom: 102px;
        }
    }

    ${Tabs} {
        border: none;
    }

    ${Tab} {
        color: ${Variables.color.pazola};
        font-family: ${Variables.font.body};
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        line-height: 100%;
        letter-spacing: 0.1em;
        width: 547px;
        margin-top: 60px;
        margin-bottom: 40px;
        border-bottom-color: ${Variables.color.pazola};
        cursor: pointer;

        ${media('<desktop')} {
            margin-top: 23px;
        }
    }
`

const StyledTitle = styled.p`
    font-family: ${Variables.font.body};
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 130%;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: ${Variables.color.pazola};
    margin: 0;
    text-align: center;
    padding-top: 57px;
`

const InteractiveMap = ({ data }) => {
    const { title, secondaryMapTitle, image, slides, id, secondaryMapImage } = data
    const { isMap, setMap, setMapOpen, ActiveMapSlide } = useContext(LayoutContext)
    const [activeMap, setActiveMap] = useState(title)
    const [interActiveMapSlider, setInterActiveMapSlider] = useState()

    useEffect(() => {
        setMap((isMap) => [...isMap, data])
    }, [])

    const activateZoom = (index) => {
        setMapOpen(id)
        if (ActiveMapSlide) {
            ActiveMapSlide.map((s, i) => {
                setTimeout(() => {
                    s.update()
                    s.slideToLoop(index, 0)
                }, 200)
            })
        }
    }

    const onChange = (swiper) => {
        setInterActiveMapSlider(swiper)
    }

    const onMobileMapPinChange = (index) => {
        if (interActiveMapSlider) {
            interActiveMapSlider.slideTo(index, 1500)
        }
    }

    return (
        <>
            <InteractiveMapWrapper>
                <MobileView>
                    <StyledTitle>Position in</StyledTitle>
                </MobileView>
                <TabsWrap>
                    <Tabs>
                        <Tab active={activeMap == title ? true : undefined} onClick={() => setActiveMap(title)}>
                            <DesktopView>{title}</DesktopView>
                            <MobileView>{title.replace(/position in/i, '')}</MobileView>
                        </Tab>
                        <Tab
                            active={activeMap == secondaryMapTitle ? true : undefined}
                            onClick={() => setActiveMap(secondaryMapTitle)}
                        >
                            <DesktopView>{secondaryMapTitle}</DesktopView>
                            <MobileView>{secondaryMapTitle.replace(/position in/i, '')}</MobileView>
                        </Tab>
                    </Tabs>
                </TabsWrap>
                <TabContent active={activeMap == title ? true : undefined} onClick={() => setActiveMap(title)}>
                    <InteractiveMapSection>
                        <Inner>
                            <Pins>
                                {slides.map((slide, i) => (
                                    <>
                                        <DesktopView>
                                            <Pin
                                                key={i}
                                                $x={slide.pinPosition.split(',')[0]}
                                                $y={slide.pinPosition.split(',')[1]}
                                                onClick={() => {
                                                    activateZoom(i)
                                                }}
                                            >
                                                <MapPin />
                                            </Pin>
                                        </DesktopView>
                                        <MobileView>
                                            <Pin
                                                key={i}
                                                $x={slide.pinPosition.split(',')[0]}
                                                $y={slide.pinPosition.split(',')[1]}
                                                onClick={() => {
                                                    onMobileMapPinChange(i)
                                                }}
                                            >
                                                <MapPin />
                                            </Pin>
                                        </MobileView>
                                    </>
                                ))}
                            </Pins>
                            <Img fluid={image.fluid} alt="" />
                        </Inner>
                    </InteractiveMapSection>
                </TabContent>
                <TabContent
                    active={activeMap == secondaryMapTitle ? true : undefined}
                    onClick={() => setActiveMap(secondaryMapTitle)}
                >
                    <InteractiveMapSection>
                        <SecondaryInner>
                            <Img fluid={secondaryMapImage.fluid} alt="" />
                        </SecondaryInner>
                    </InteractiveMapSection>
                </TabContent>
                <MobileView>
                    <InteractiveMapSlider onSlideChange={onChange} data={data} isMap={isMap} />
                </MobileView>
            </InteractiveMapWrapper>
        </>
    )
}

export default InteractiveMap
